module.exports = __webpack_public_path__ + "img/location.4b0ff2f3.svg";